import styles from '../../article.module.css';

export const VirtualAnchor = ({ name }: AnchorProps) => {
	return <span id={name} className={styles['anchor']} />;
};

interface AnchorProps {
	name: string;
}
